import Product from "../../../../../@types/Product"

const Tires12In: Product[] = [
    {
        id: 1,
        refId: 12,
        name: '215/50-R12 GTW® Fusion S/R Steel Belted Tire x4',
        sku: '20-063',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/tires/12-inch/gtw-r12-fusion-steel-belted-tire-300x300.jpg`,
        price: 190.00,
        retailPrice: 0.00,
    },
]

const Tires12InLifted: Product[] = [
    {
        id: 2,
        refId: 12,
        name: '22x11-R12 GTW® Nomad Steel Belted Radial DOT Tire x4',
        sku: '20-065',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/tires/12-inch/gtw-r12-nomad-steel-belted-radial-300x300.jpg`,
        price: 250.00,
        retailPrice: 0.00,
    },
]

const Tires14In: Product[] = [
    {
        id: 3,
        refId: 14,
        name: '205/40-R14 GTW® Fusion GTR Steel Belted Tire x4',
        sku: '20-054',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/tires/14-inch/gtw-r14-fusion-215-50-steel-belted-tire-300x300.jpg`,
        price: 210.00,
        retailPrice: 0.00,
    },
]

const Tires14InLifted: Product[] = [
    {
        id: 4,
        refId: 14,
        name: '23x10-R14 GTW® Nomad Steel Belted Radial DOT Tire x4',
        sku: '20-064',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/tires/14-inch/gtw-r14-nomad-steel-belted-radial-300x300.jpg`,
        price: 270.00,
        retailPrice: 50.00,
    },
]

const Tires15In: Product[] = [
    {
        id: 5,
        refId: 15,
        name: '23x10-R15 GTW® Nomad Steel Belted Radial DOT Tire x4',
        sku: '20-073',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/tires/15-inch/gtw-r15-fusion-215-50-steel-belted-tire-300x300.jpg`,
        price: 230.00,
        retailPrice: 0.00,
    },
]

const Tires15InLifted: Product[] = [
    {
        id: 6,
        refId: 15,
        name: '215/40-R15 GTW® Nomad GTR Steel Belted DOT Tire x4',
        sku: '20-072',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/tires/15-inch/gtw-r15-nomad-steel-belted-radial-300x300.jpg`,
        price: 290.00,
        retailPrice: 0.00,
    },
]

export { 
    Tires12In, 
    Tires12InLifted, 
    Tires14In, 
    Tires14InLifted, 
    Tires15In, 
    Tires15InLifted 
}